var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "cart") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 4.502v1.5h14.25v2.969l-1.664 5.281h-13.058l-1.875-13.502h-4.403v1.5h3.097l1.875 13.502h15.464l2.064-6.55v-4.7h-15.75z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.296 17.266c-1.656 0.002-2.998 1.344-3 3v0c0 1.657 1.343 3 3 3s3-1.343 3-3v0-0c-0.002-1.656-1.344-2.998-3-3h-0zM8.296 21.766c-0.828 0-1.5-0.672-1.5-1.5s0.672-1.5 1.5-1.5c0.828 0 1.5 0.672 1.5 1.5v0c-0.001 0.828-0.672 1.499-1.5 1.5h-0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.796 17.266c-1.656 0.002-2.998 1.344-3 3v0c0 1.657 1.343 3 3 3s3-1.343 3-3v0-0c-0.002-1.656-1.344-2.998-3-3h-0zM18.796 21.766c-0.828 0-1.5-0.672-1.5-1.5s0.672-1.5 1.5-1.5c0.828 0 1.5 0.672 1.5 1.5v0c-0.001 0.828-0.672 1.499-1.5 1.5h-0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.b9084766f00ddf30c19efeb43b45aa0e.svg";
export { ForwardRef as ReactComponent };